import './testOrderResultComponent.scss';
import React, {useEffect, useCallback, useState} from 'react';
import {CommonService} from "../../../../shared/services";
import TestOrderResultTableComponent from "./test-order-result-list/testOrderResultTable";
import SearchComponent from "../../../../shared/components/search/SearchComponent";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import ButtonComponent from "../../../../shared/components/core/button/ButtonComponent";
import RestorePageIcon from '@mui/icons-material/RestorePage';
import AutoCompleteDropdownComponent
    from "../../../../shared/components/core/auto-complete-dropdown/autoCompleteDropdownComponent";
import FileDragAndDropComponent from "../../../../shared/components/file-drag-n-drop/FileDragAndDropComponent";
import DialogComponent from "../../../../shared/components/dialog/dialogComponent";
import {IAPIResponseType} from "../../../../shared/models/api.model";
import commonService from "../../../../shared/services/common.service";
import {AttachFile} from "@mui/icons-material";
import ChipComponent from "../../../../shared/components/chip/ChipComponent";

interface TestOrderResultComponentProps {
    testOrderId: any;
    onModeChange: Function;
}

const MODULE_NAME = 'test-order-result-table';

const TestOrderResultComponent = (props: TestOrderResultComponentProps) => {
        const {testOrderId, onModeChange} = props;
        const {currentUser} = useSelector((state: IRootReducerState) => state.account);

        const [isUploadUpdatedResultDialogOpen, showUploadUpdatesResultDialogOpen] = useState<boolean>(false);
        const [resultAttachmentFile, setResultAttachmentFile] = useState<File | undefined>(undefined);
        const [isAttachmentBeingUploaded, setIsAttachmentBeingUploaded] = useState<boolean>(false);
        const [sampleDetails, setSampleDetails] = React.useState<any>(undefined);
        const [testList, setTestList] = useState<any>([]);
        const [isTestListLoading, setIsTestListLoading] = useState<any>([]);
        const [isTestListLoaded, setIsTestListLoaded] = useState<any>([]);
        const [isTestListLoadingFailed, setIsTestListLoadingFailed] = useState<any>([]);


        const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
        const [filterData, setFilterData] = useState<any>({
            search: '',
            orderId: testOrderId
        });

        const handleSearch = useCallback((value: string) => {
            setFilterData((prevState: any) => ({
                ...prevState,
                search: value
            }));
            CommonService.setQueryParam('search', value);
        }, []);

        useEffect(() => {
            if (queryParamData) {
                setFilterData((prevState: any) => ({
                    ...prevState,
                    search: queryParamData.search || '',
                }));
            }
        }, [queryParamData]);

        useEffect(() => {
            onModeChange('view')
        }, [onModeChange]);

        const closeUploadXlsDialogComponent = useCallback(() => {
            setSampleDetails('');
            setResultAttachmentFile(undefined);
            showUploadUpdatesResultDialogOpen(false);
        }, [setSampleDetails, setResultAttachmentFile, showUploadUpdatesResultDialogOpen])

        const getTestList = useCallback(() => {
            const payload = {isActive: true};
            setIsTestListLoading(true);
            setIsTestListLoaded(false);
            setIsTestListLoadingFailed(false);
            let testOrderGrouping: any = [];
            CommonService._testOrder.getTestOrderSampleList(testOrderId, payload)
                .then((response: IAPIResponseType<any>) => {
                    if (response?.data) {
                        testOrderGrouping = response?.data;
                    }
                    const pdfGeneratedSamples: any = [];
                    testOrderGrouping?.forEach((testOrderSamples: any) => {
                            testOrderSamples?.sample?.forEach((sample: any) => {
                                    if (sample?.isPdfGenerated) {
                                        pdfGeneratedSamples.push(sample);
                                    }
                                }
                            )
                        }
                    );
                    setTestList(pdfGeneratedSamples);
                    setIsTestListLoading(false);
                    setIsTestListLoaded(true);
                    setIsTestListLoadingFailed(false);
                })
                .catch((error: any) => {
                    setIsTestListLoading(false);
                    setIsTestListLoaded(false);
                    setIsTestListLoadingFailed(true);
                });
        }, [testOrderId]);

        useEffect(() => {
            if (testOrderId) {
                getTestList();
            }
        }, [testOrderId, getTestList])

        const handleResultFilesDrop = useCallback((files: any) => {
            const file = files[0];
            setResultAttachmentFile(file);
        }, []);

        const uploadXlsResult = useCallback(() => {
            const formData = new FormData();
            if (resultAttachmentFile) {
                formData.append('file', resultAttachmentFile);
            }
            formData.append('orderId', testOrderId);
            setIsAttachmentBeingUploaded(true);
            CommonService._result.correctResult(sampleDetails?.id, formData)
                .then((response: IAPIResponseType<any>) => {
                    if (response.success) {
                        closeUploadXlsDialogComponent();
                        setIsAttachmentBeingUploaded(false);
                        CommonService._communications.TableWrapperRefreshSubject.next({
                            moduleName: MODULE_NAME
                        });
                    }
                })
                .catch((error: any) => {
                    CommonService._alert.showToast(error?.message || 'Error uploading order attachment', "error");
                    setIsAttachmentBeingUploaded(false);
                })

        }, [resultAttachmentFile, closeUploadXlsDialogComponent, sampleDetails, testOrderId]);

        return (
            <div className="testOrder-order-history-list-component">
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search Sample"}
                                id="search_input"
                                placeholder={""}
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="page-extra-options">
                            {commonService.checkAccess('TestOrder', 'testOrderResultCorrection', currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    color={"secondary"}
                                    variant={"outlined"}
                                    startIcon={<RestorePageIcon/>}
                                    disabled={testList.length === 0}
                                    handleClick={() => {
                                        showUploadUpdatesResultDialogOpen(true);
                                    }}
                                >
                                    Result Correction
                                </ButtonComponent>
                            }
                        </div>
                    </div>
                    <div className="">
                        <TestOrderResultTableComponent filterData={filterData}/>
                    </div>
                </div>
                <DialogComponent open={isUploadUpdatedResultDialogOpen}
                                 onClose={closeUploadXlsDialogComponent}
                                 title="Upload the updated result file"
                                 isShowCancel={false}
                                 maxWidth={"sm"}>
                    <div className="file-upload-wrapper mrg-top-10">
                        <AutoCompleteDropdownComponent
                            fullWidth={true}
                            isDataLoading={isTestListLoading}
                            isDataLoadingFailed={isTestListLoadingFailed}
                            isDataLoaded={isTestListLoaded}
                            name={'test'}
                            label={'Select Test'}
                            required={true}
                            multiple={false}
                            data={testList}
                            valueKey={'id'}
                            value={sampleDetails}
                            onSelectUpdate={(value: any) => {
                                setSampleDetails(value)
                            }}
                            getOptionLabel={(option => (option?.testDetails?.name) || '')}
                        />
                        {
                            !resultAttachmentFile &&
                            <FileDragAndDropComponent
                                onFilesDrop={handleResultFilesDrop}
                                acceptedFileTypes={{'application/pdf': []}}
                                fileSizeLimitText={"PDF smaller than 5MB"}
                            />
                        }
                        <div className="file-upload-selected-file-action-buttons-wrapper">
                            <div className="file-upload-selected-files-details">
                                {resultAttachmentFile &&
                                    <ChipComponent
                                        label={resultAttachmentFile?.name}
                                        onDelete={() => {
                                            setResultAttachmentFile(undefined);
                                        }}
                                        icon={<AttachFile/>}
                                        className={'attachment-chip-item'}
                                    />
                                }
                            </div>
                            <div className="file-upload-action-buttons">
                                <ButtonComponent variant={"outlined"}
                                                 handleClick={closeUploadXlsDialogComponent}
                                                 disabled={isAttachmentBeingUploaded}
                                                 fullWidth={true}
                                                 color={"primary"}>
                                    Cancel
                                </ButtonComponent>&nbsp;
                                <ButtonComponent variant={"contained"}
                                                 handleClick={uploadXlsResult}
                                                 disabled={isAttachmentBeingUploaded || !resultAttachmentFile || !sampleDetails}
                                                 isLoading={isAttachmentBeingUploaded}
                                                 fullWidth={true}
                                                 color={"primary"}
                                >
                                    Proceed
                                </ButtonComponent>
                            </div>
                        </div>
                    </div>
                </DialogComponent>

            </div>

        )
    }

;

export default TestOrderResultComponent;

